import BaseApiService from './baseApiService';
import {
    GetCouponEditsRequest,
    CouponEditsRequestFilter,
    ExportCouponEditsRequest,
    ImportReportDataResult,
    CouponEditsDto
} from '../contracts';
import { RcFile } from 'antd/lib/upload';

class CouponEditsApiService extends BaseApiService {
    loadCouponEdits = (query: GetCouponEditsRequest) => {
        return this.post<CouponEditsDto, GetCouponEditsRequest>('report-data/coupon-edits', query);
    };

    uploadCouponEdits = (file: RcFile) => {
        const form = new FormData();
        form.append('file', file);
        return this.post<ImportReportDataResult, FormData>('report-data/coupon-edits/import', form);
    };

    downloadCouponEdits = (filter: CouponEditsRequestFilter) => {
        return this.downloadFilePost<ExportCouponEditsRequest>('report-data/coupon-edits/export/tsv', {
            filter
        });
    };

    deleteCouponEdits = (ids: number[]) => {
        return this.delete('report-data/coupon-edits', { data: { ids } });
    };
}

export default new CouponEditsApiService();
